export default __webpack_public_path__ + "static/media/G0860.breech_footling2.1692872820000.5496dc0c.jpg";